import { render, staticRenderFns } from "./payrollAssessment.vue?vue&type=template&id=d0cf0d92&scoped=true"
import script from "./payrollAssessment.vue?vue&type=script&lang=js"
export * from "./payrollAssessment.vue?vue&type=script&lang=js"
import style0 from "./payrollAssessment.vue?vue&type=style&index=0&id=d0cf0d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cf0d92",
  null
  
)

export default component.exports